import React from 'react';
import { CodelessIcon, ManuallyIcon } from 'tuui';
import { Radio, RadioGroup } from 'taboola-ultimate-ui';
import { useAvailableItems } from 'hooks';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { RecommendedTag } from '../../../../components/RecommendedTag/RecommendedTag';
import { ENTITY } from '../../config';
import styles from './trackingSetupCodelessConversionMethodRadioGroup.module.scss';

const configs = [
    {
        id: ENTITY.CODELESS_EVENT_TOOL,
        icon: CodelessIcon,
        label: (
            <FormattedMessage
                id="tracking.setup.modal.codeless.label"
                tagName="h4"
                defaultMessage="Codeless event tool"
            />
        ),
        badgeComponent: <RecommendedTag />,
        subtext: (
            <FormattedMessage
                id="tracking.setup.modal.codeless.description"
                defaultMessage="Quickly set up conversion events by interactively selecting elements on your site—then verify your setup using our built-in testing tool"
            />
        ),
    },
    {
        id: ENTITY.CONVERSION,
        icon: ManuallyIcon,
        label: (
            <FormattedMessage
                id="tracking.setup.modal.conversion.label"
                tagName="h4"
                defaultMessage="Create conversions using code"
            />
        ),
        subtext: (
            <FormattedMessage
                id="tracking.setup.modal.conversion.description"
                defaultMessage="Manually create conversion events by adding custom code snippets to your web pages"
            />
        ),
    },
];

const TrackingSetupMethodRadioItem = ({ Icon, label, subtext, badgeComponent }) => (
    <div className={styles['radio-container']}>
        <div className={styles['icon-wrapper']}>
            <Icon />
        </div>
        <div className={styles['label-container']}>
            <div className={styles['label-header']}>
                {label}
                {badgeComponent}
            </div>
            <span className={styles['desc']}>{subtext}</span>
        </div>
    </div>
);

export const TrackingSetupCodelessConversionMethodRadioGroup = ({ type, setType }) => {
    const options = useAvailableItems(configs);

    return (
        <RadioGroup
            id="tracking_setup_method_radio_group"
            name="tracking_setup_method_radio_group"
            selectedValue={type}
            onChange={setType}
            className={styles['group']}
        >
            {options.map(({ id, icon: Icon, label, subtext, badgeComponent }) => {
                return (
                    <Radio key={id} value={id} labelClassName={styles['radio']} title="">
                        <TrackingSetupMethodRadioItem
                            Icon={Icon}
                            label={label}
                            subtext={subtext}
                            badgeComponent={badgeComponent}
                        />
                    </Radio>
                );
            })}
        </RadioGroup>
    );
};

export default TrackingSetupCodelessConversionMethodRadioGroup;
